import { LinearProgressProps } from "@mui/material";

interface IResolveRydeProgressColorArguments {
  isFinished: boolean;
  error: string | null | unknown;
  hasConflictError?: boolean;
  isAborting?: boolean;
}

export const resolveRydeProgressColor = ({
  isFinished,
  error,
  hasConflictError,
  isAborting,
}: IResolveRydeProgressColorArguments): LinearProgressProps["color"] => {
  if (isFinished) {
    return "success";
  }

  if (isAborting) {
    return "error";
  }

  if (error) {
    return "error";
  }

  if (hasConflictError) {
    return "secondary";
  }

  return "primary";
};
